import api from './api';

// MIGRATION: Removed independent agent routing logic
// All agents now use unified /clients endpoints
// Backend handles role-based filtering automatically

export const clientsService = {
  // Get all clients
  getAll: async () => {
    const response = await api.get('/clients');
    return response.data;
  },

  // Get single client
  getById: async (id) => {
    const response = await api.get(`/clients/${id}`);
    return response.data;
  },

  // Create new client
  create: async (clientData) => {
    const response = await api.post('/clients', clientData);
    return response.data;
  },

  // Update client
  update: async (id, clientData) => {
    const response = await api.put(`/clients/${id}`, clientData);
    return response.data;
  },

  // Delete client
  delete: async (id) => {
    const response = await api.delete(`/clients/${id}`);
    return response.data;
  },

  // Get client quotes
  getClientQuotes: async (clientId) => {
    const response = await api.get(`/clients/${clientId}/quotes`);
    return response.data;
  },

  // Get client itineraries
  getClientItineraries: async (clientId) => {
    const response = await api.get(`/clients/${clientId}/itineraries`);
    return response.data;
  },

  // Download CSV import template
  downloadTemplate: async () => {
    const response = await api.get('/clients/import-template', {
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'client_import_template.csv');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  // Bulk import clients from CSV
  bulkImport: async (csvFile) => {
    const formData = new FormData();
    formData.append('csvFile', csvFile);
    
    const response = await api.post('/clients/bulk-import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    return response.data;
  }
};
